import React from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import type { Feature } from '@atlassian/jira-servicedesk-common/src/service-project-features/types.tsx';
import { FeatureTile, type FeatureTileProps } from '../feature-tile';
import { FeatureToggle, type FeatureToggleProps } from './feature-toggle';

type FeatureToggleTileProps = Omit<FeatureTileProps, 'input'> & FeatureToggleProps<Feature>;

export const FeatureToggleTile = ({
	feature,
	value,
	saving,
	disabled,
	onChange,
	tooltip,
	focusToggle = false,
	isPopperOpenByDefault,
	...featureTileProps
}: FeatureToggleTileProps) => {
	const id = `FeatureTile-${featureTileProps.title.replace(/\s+/g, '-').toLowerCase()}`;

	return (
		<FeatureTile
			{...featureTileProps}
			input={
				<FeatureToggle
					feature={feature}
					value={value}
					saving={saving}
					disabled={disabled}
					focusToggle={focusToggle}
					onChange={onChange}
					popperText={tooltip}
					labelId={id}
					{...(ff('enable_jsm_repackaging_changes_vtwk9')
						? {
								isPopperOpenByDefault,
							}
						: {})}
				/>
			}
		/>
	);
};

type FeaturesToggleTileProps = Omit<FeatureTileProps, 'input'> &
	Omit<FeatureToggleProps<Feature[]>, 'feature'> & {
		features: Feature[];
	};

export const FeaturesToggleTile = ({
	features,
	value,
	saving,
	disabled,
	onChange,
	tooltip,
	focusToggle = false,
	isPopperOpenByDefault,
	...featureTileProps
}: FeaturesToggleTileProps) => {
	const id = `FeatureTile-${featureTileProps.title.replace(/\s+/g, '-').toLowerCase()}`;

	return (
		<FeatureTile
			{...featureTileProps}
			input={
				<FeatureToggle
					feature={features}
					value={value}
					saving={saving}
					disabled={disabled}
					focusToggle={focusToggle}
					onChange={onChange}
					popperText={tooltip}
					labelId={id}
					{...(ff('enable_jsm_repackaging_changes_vtwk9')
						? {
								isPopperOpenByDefault,
							}
						: {})}
				/>
			}
		/>
	);
};
